export { default } from './News';